import React from "react";
import { Component } from "react";
import classNames from "../../utils/classNames";
import { TwitterTweetEmbed } from "react-twitter-embed";

class Embed extends Component {
  constructor(props) {
    super(props);
    this.state = {
      url: props.url,
      embedUrl: null,
      wrapperClass: null,
      service: null,
    };
    this.embedUrlForYoutube = this.embedUrlForYoutube.bind(this);
    this.embedUrlForTwitter = this.embedUrlForTwitter.bind(this);
  }
  componentDidMount() {
    this.buildEmbedData(this.state.url);
  }
  // TODO: revisit
  buildEmbedData(url) {
    // Here's a map of the embeds we want to support
    // The key for each service is the string you want to match
    // Service is a string that will be appended to the iFrame wrapper class
    // cleanUrlFunction is a function that takes the URL to embed and returns
    // the embedable URL for the service
    const embedServiceMap = {
      youtu: {
        service: "youtube",
        cleanUrlFunction: this.embedUrlForYoutube,
      },
      twitt: {
        service: "twitter",
        cleanUrlFunction: this.embedUrlForTwitter,
      },
      track: {
        service: "spotifyTrack",
        cleanUrlFunction: this.embedUrlForSpotify,
      },
      show: {
        service: "spotifyShow",
        cleanUrlFunction: this.embedUrlForSpotify,
      },
      episode: {
        service: "spotifyShow",
        cleanUrlFunction: this.embedUrlForSpotify,
      },
      playlist: {
        service: "spotifyPlaylist",
        cleanUrlFunction: this.embedUrlForSpotify,
      },
    };
    const serviceKey = Object.keys(embedServiceMap).find((key) => {
      return url.includes(key);
    });
    try {
      const serviceMap = embedServiceMap[serviceKey];
      const embedUrl = serviceMap.cleanUrlFunction(url);
      this.setState({
        embedUrl: embedUrl,
        wrapperClass: `coop-c-embed-object__wrapper--${serviceMap.service}`,
        service: serviceMap.service,
      });
    } catch (err) {
      throw new Error(`Embed not supported for url ${url}`);
    }
  }
  embedUrlForSpotify(url) {
    return `https://embed.spotify.com/?uri=${url}`;
  }
  embedUrlForYoutube(url) {
    const mediaId = this.getYoutubeIdFromUrl(url);
    return `https://youtube.com/embed/${mediaId}`;
  }
  embedUrlForTwitter(url) {
    return this.getTweetIdFromUrl(url);
  }
  getYoutubeIdFromUrl(url) {
    const youtubeMatcher = /(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|vi|e(?:mbed)?)\/|\S*?[?&]v=|\S*?[?&]vi=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    return url.match(youtubeMatcher) ? RegExp.$1 : false;
  }
  getTweetIdFromUrl(url) {
    const twitterMatcher = /https?:\/\/twitter\.com\/(?:\#!\/)?(?:\w+)\/status(?:es)?\/(\d+)/;
    return url.match(twitterMatcher) ? RegExp.$1 : false;
  }
  render() {
    const classes = classNames(this.state.wrapperClass, [
      this.props.className,
      "coop-c-embed-object__wrapper coop-u-margin-resp-b-48-32 coop-u-margin-resp-t-48-32",
    ]);
    const isTwitter = this.state.service === "twitter";
    let embed;
    if (isTwitter) {
      embed = <TwitterTweetEmbed tweetId={this.state.embedUrl} />;
    } else {
      embed = (
        <iframe
          frameBorder="0"
          className="coop-c-embed-object"
          src={this.state.embedUrl}
          title="test"
        ></iframe>
      );
    }
    return <div className={classes}>{embed}</div>;
  }
}

export default Embed;
